import { createContext } from "react";

export type FeatureFlags = Record<string, boolean>;

export const FeatureFlagContext = createContext<FeatureFlags>({});
